import { Module } from 'vuex';
import { fields } from '@signing-page/fields/store/field.store';
import { mutations } from '@signing-page/documents/store/document.mutations';
import { actions } from '@signing-page/documents/store/document.actions';
import { getters } from '@signing-page/documents/store/document.getters';
import { IRootState } from '@signing-page/store/store';
import { IDocument } from '@signing-page/documents/types/document';

export const namespace = 'document';

export interface IDocumentState {
  isLoading: boolean;
  revisionsIsLoading: boolean;
  revisionsViewedLoading: boolean;
  isButtonLoading: boolean;
  forwarded: boolean;
  document: IDocument;
  focusedRequiredId: string;
  uploadingAttachmentIds: string[];
  error?: boolean;
  pdfUrl: string;
  isDownloading: boolean;
}
export const state: IDocumentState = {
  isLoading: true,
  revisionsIsLoading: false,
  revisionsViewedLoading: false,
  isButtonLoading: false,
  forwarded: false,
  document: null,
  focusedRequiredId: null,
  uploadingAttachmentIds: [],
  error: false,
  pdfUrl: '',
  isDownloading: false,
};

const namespaced = true;

export const document: Module<IDocumentState, IRootState> = {
  actions,
  mutations,
  getters,
  namespaced,
  state,
  modules: {
    fields,
  },
};
